import DOMPurify from 'dompurify';

const MAINTENANCE_PURIFY_CONFIG: DOMPurify.Config = {
  ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'b', 'i', 'h2', 'h3', 'ul', 'ol', 'li', 'a'],
  ALLOWED_ATTR: ['href', 'title', 'target', 'rel'],
  ALLOW_DATA_ATTR: false,
};

export function sanitizeMaintenanceHtml(html: string): string {
  if (!html?.trim()) {
    return '';
  }
  return DOMPurify.sanitize(html, MAINTENANCE_PURIFY_CONFIG);
}

export function sanitizeMaintenanceTitle(title: string): string {
  return DOMPurify.sanitize(title, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }).trim();
}
